import { DeletionImpact } from "../../../services";

export const isDeletionBlocked = (
  impact?: Pick<DeletionImpact, "linkedBrokers"> | null,
): boolean => (impact?.linkedBrokers?.length ?? 0) > 0;
